export default {
  paused: 'Plățile online sunt suspendate din cauza unor probleme de verificare KYC.',
  deadline_warning: 'Verificarea KYC este obligatorie, altfel plățile online vor fi suspendate pe {{date}}.',
  complete_verification: 'Finalizați verificarea',
  partner: {
    action_needed:
      'Furnizorul tău de plăți mai are nevoie de un lucru înainte ca acest restaurant să poată accepta plăți online.',
    hosted_incomplete: 'Nu ai finalizat încă configurarea plăților online cu furnizorul tău de plăți.',
    link_expired: 'Linkul pentru finalizarea configurării plăților online a expirat. Obține unul nou și continuă.',
    open_error: 'Furnizorul de plăți nu a putut fi contactat. Încearcă din nou peste câteva minute.',
    hosted_not_started: 'Plățile online nu au fost încă configurate cu furnizorul tău de plăți.',
    business_details_missing: 'Adaugă detaliile afacerii tale pentru a începe să accepți plăți online.',
    continue: 'Continuă',
  },
};
